import {
  FETCH_ALL_DRIVERS_STATUS,
  FETCH_ALL_DRIVERSTATUS_SUCCESS,
  FETCH_ALL_DRIVERSTATUS_FAILED,
  ADD_DRIVERSTATUS,
  ADD_DRIVERSTATUS_SUCCESS,
  ADD_DRIVERSTATUS_FAILED,
  DELETE_DRIVERSTATUS,
  DELETE_DRIVERSTATUS_SUCCESS,
  DELETE_DRIVERSTATUS_FAILED,
} from "../store/types";
import {
  cloud_function_server_url
} from '../../config';

const END_POINT = `${cloud_function_server_url}/user`;

export const fetchDriverStatus = (email, start, end) => (dispatch) => (firebase) => {

  dispatch({
    type: FETCH_ALL_DRIVERS_STATUS,
    payload: null
  });

  fetch(`${END_POINT}/fetch-driver-status?email=${email}&start=${start}&end=${end}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    // body: JSON.stringify({
    //   phone: phoneNumber
    // })
  }).then(async res => {
    const response = await res.json();
    const data = response.data;
    const arr = data.map((item) => {
      const itemCopy = {...item};
      itemCopy.id = item._id;
      return itemCopy;
    });
    dispatch({
      type: FETCH_ALL_DRIVERSTATUS_SUCCESS,
      payload: arr
    });
  })
    .catch(error => {
      console.log("requestPhoneOtpDevice error", error)
      dispatch({
        type: FETCH_ALL_DRIVERSTATUS_FAILED,
        payload: "No status available."
      });
    });

  // driverstatusRef.on("value", snapshot => {
  //   if (snapshot.val()) {
  //     const data = snapshot.val();
  //     const arr = Object.keys(data)
  //       .map(i => {
  //         data[i].id = i;
  //         return data[i];
  //       });
  //     dispatch({
  //       type: FETCH_ALL_DRIVERSTATUS_SUCCESS,
  //       payload: arr
  //     });
  //   } else {
  //     dispatch({
  //       type: FETCH_ALL_DRIVERSTATUS_FAILED,
  //       payload: "No status available."
  //     });
  //   }
  // });
};

export const addDriverStatus = (statusdata) => (dispatch) => (firebase) => {
  const {
    driverstatusRef
  } = firebase;

  dispatch({
    type: ADD_DRIVERSTATUS,
    payload: statusdata
  });

  driverstatusRef.push(statusdata).then(() => {
    dispatch({
      type: ADD_DRIVERSTATUS_SUCCESS,
      payload: null
    });
  }).catch((error) => {
    dispatch({
      type: ADD_DRIVERSTATUS_FAILED,
      payload: error
    });
  });
}

export const deleteDriverStatus = (id) => (dispatch) => (firebase) => {

  const {
    singleDriverStatusRef
  } = firebase;

  dispatch({
    type: DELETE_DRIVERSTATUS,
    payload: id
  });

  singleDriverStatusRef(id).remove().then(() => {
    dispatch({
      type: DELETE_DRIVERSTATUS_SUCCESS,
      payload: null
    });
  }).catch((error) => {
    dispatch({
      type: DELETE_DRIVERSTATUS_FAILED,
      payload: error
    });
  });
}

export const editDriverStatus = (email) => (dispatch) => (firebase) => {

  const {
    singleDriverStatusRef
  } = firebase;

  singleDriverStatusRef(email).once('value', snapshot => {
    // dispatch({
    //   type: EDIT_DRIVERSTATUS_SUCCESS,
    //   payload: null
    // });
  }).catch((error) => {
    // dispatch({
    //   type: EDIT_DRIVERSTATUS_FAILED,
    //   payload: error
    // });
  });
}

export const filterDriverStatus = (email, datefrom, dateto) => (dispatch) => (firebase) => {
  const {
    driverstatusRef
  } = firebase;

  dispatch({
    type: FETCH_ALL_DRIVERS_STATUS,
    payload: null
  });

  if (email && datefrom && dateto) {
    driverstatusRef.orderByChild("date").startAt(datefrom).endAt(dateto).once("value", snapshot => {
      if (snapshot.val()) {
        const data = snapshot.val();
        const arr = Object.keys(data)
          .map(i => {
            data[i].id = i;
            return data[i];
          });
        const driver = arr.map(item => item.driver_email == email);
        dispatch({
          type: FETCH_ALL_DRIVERSTATUS_SUCCESS,
          payload: driver
        });
      } else {
        dispatch({
          type: FETCH_ALL_DRIVERSTATUS_FAILED,
          payload: null
        });
      }
    });
  } else if (email && datefrom === "" && dateto === "") {
    driverstatusRef.orderByChild("driver_email").equalTo(email).once("value", snapshot => {
      if (snapshot.val()) {
        const data = snapshot.val();
        const arr = Object.keys(data)
          .map(i => {
            data[i].id = i;
            return data[i];
          });
        dispatch({
          type: FETCH_ALL_DRIVERSTATUS_SUCCESS,
          payload: arr
        });
      } else {
        dispatch({
          type: FETCH_ALL_DRIVERSTATUS_FAILED,
          payload: null
        });
      }
    });
  } else if (email === "" && datefrom && dateto) {
    driverstatusRef.orderByChild("date").startAt(datefrom).endAt(dateto).once("value", snapshot => {
      if (snapshot.val()) {
        const data = snapshot.val();
        const arr = Object.keys(data)
          .map(i => {
            data[i].id = i;
            return data[i];
          });
        dispatch({
          type: FETCH_ALL_DRIVERSTATUS_SUCCESS,
          payload: arr
        });
      } else {
        dispatch({
          type: FETCH_ALL_DRIVERSTATUS_FAILED,
          payload: null
        });
      }
    });
  } else {
    driverstatusRef.on("value", snapshot => {
      if (snapshot.val()) {
        const data = snapshot.val();
        const arr = Object.keys(data)
          .map(i => {
            data[i].id = i;
            return data[i];
          });
        dispatch({
          type: FETCH_ALL_DRIVERSTATUS_SUCCESS,
          payload: arr
        });
      } else {
        dispatch({
          type: FETCH_ALL_DRIVERSTATUS_FAILED,
          payload: "No status available."
        });
      }
    });
  }
}